<template>
  <new-page-base
    :loading="loadingBillingTemplatePreview || loadingBillingTemplates"
    @back="goBack"
    showBackText="Faturas">

    <template slot="titleLeft">
      {{ pageTitle }}
    </template>
    <span v-if="!isViewMode">
      <p class="header-message">Adicione um novo modelo de fatura e identifique os valores divergentes da fatura de uma nova transportadora.</p>
      <p class="header-message">Se tiver dificuldade em criar um novo modelo,
        <a href="https://esprinter.atlassian.net/servicedesk/customer/portal/9/group/36/create/162" target="_blank">
          fale com nosso suporte
        </a>
      </p>
    </span>
    <section class="page-content">
      <billing-template-view-mode v-if="isViewMode" :template-id="$route.query.view"/>
      <new-billing-template-wizard v-else />
    </section>
    <section class="page-modal">
      <sc-confirmation-modal
        :is-active.sync="isExitModalActive"
        type="primary"
        title="Sair sem salvar?"
        cancelText="Fechar"
        confirm-text="Sair mesmo assim"
        :messages="[
            'Ao sair da criação de modelo de fatura, as alterações feitas não serão salvas.',
            'Tem certeza que deseja sair?'
        ]"
        @onConfirm="() => this.$router.push({ name: 'billing-main-page' })"
      />
    </section>
  </new-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import NewPageBase from '../../../../components/new-page-base/NewPageBase';
import NewBillingTemplateWizard from './components/NewBillingTemplateWizard.vue';
import BillingTemplateViewMode from './components/BillingTemplateViewMode.vue';
import ScConfirmationModal from '../../../../components/sc-confirmation-modal/ScConfirmationModal.vue';

const { mapState } = createNamespacedHelpers('recon/billing');

export default {
  name: 'create-billing-template',
  data() {
    return {
      isViewMode: this.$route.query.view,
      isExitModalActive: false,
    };
  },
  components: {
    NewPageBase,
    NewBillingTemplateWizard,
    BillingTemplateViewMode,
    ScConfirmationModal,
  },
  computed: {
    ...mapState(['loadingBillingTemplates', 'loadingBillingTemplatePreview']),
    pageTitle() {
      return this.isViewMode ? 'Visualizar modelo criado' : 'Novo modelo de fatura';
    },
  },
  methods: {
    goBack() {
      this.isExitModalActive = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.header-message a {
  color: $primary;
  font-weight: 700;
}

.page-content {
  margin-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/PageBillingTemplates.vue